import { useCallback, useContext } from 'react';
import type { WorkspaceGlobalSearchBarFilter } from '@/types';
import { WorkspaceGlobalSearchBarFiltersContext, WorkspaceGlobalSearchBarQueryContext } from './Context';
import FiltersCheckbox from './Filters.Checkbox';
import styles from './style/Filters.module.css';

export default function Filters() {
  const { activeFilters, setActiveFilters, aggregationsFilters } = useContext(WorkspaceGlobalSearchBarFiltersContext);
  const { query } = useContext(WorkspaceGlobalSearchBarQueryContext);
  //const isInternalUser = useIsInternalUser();
  const handleChange = useCallback((filter: WorkspaceGlobalSearchBarFilter, checked: boolean) => {
    setActiveFilters(prev => ({ ...prev, [filter]: checked }));
  }, [setActiveFilters]);

  if (!query.length) return null;

  return (
    <div className={styles.root}>
      <div className={styles.title}>Filter By</div>
      <div className={styles.filters}>
        <FiltersCheckbox
          aggregation={aggregationsFilters['brand']}
          className={styles.check}
          checked={activeFilters['brand']}
          onChange={(_, checked) => handleChange('brand', checked)}
          label="Brands" />
        <FiltersCheckbox
          aggregation={aggregationsFilters['project']}
          className={styles.check}
          checked={activeFilters['project']}
          onChange={(_, checked) => handleChange('project', checked)}
          label="Projects" />
        <FiltersCheckbox
          aggregation={aggregationsFilters['folder']}
          className={styles.check}
          checked={activeFilters['folder']}
          onChange={(_, checked) => handleChange('folder', checked)}
          label="Folders" />
        <FiltersCheckbox
          aggregation={aggregationsFilters['file']}
          className={styles.check}
          checked={activeFilters['file']}
          onChange={(_, checked) => handleChange('file', checked)}
          label="Files" />
        <FiltersCheckbox
          aggregation={aggregationsFilters['transcript']}
          className={styles.check}
          checked={activeFilters['transcript']}
          onChange={(_, checked) => handleChange('transcript', checked)}
          label="Transcripts" />
        <FiltersCheckbox
          aggregation={aggregationsFilters['dashboard']}
          className={styles.check}
          checked={activeFilters['dashboard']}
          onChange={(_, checked) => handleChange('dashboard', checked)}
          label="Dashboards" />
        <FiltersCheckbox
          aggregation={aggregationsFilters['tag']}
          className={styles.check}
          checked={activeFilters['tag']}
          onChange={(_, checked) => handleChange('tag', checked)}
          label="Tags" />
        <FiltersCheckbox
          aggregation={aggregationsFilters['quantanalyses']}
          className={styles.check}
          checked={activeFilters['quantanalyses']}
          onChange={(_, checked) => handleChange('quantanalyses', checked)}
          label="Analyses" />
      </div>
    </div>
  );
}

export { Filters };